import _ from 'lodash';
import TranslationService from '../../services/translation.service';

let translationService = new TranslationService();

function getCommonParams() {
    return _.cloneDeep({
        appId: 'assurance',
        captureType: 'page',
        level: 'view',
        page: 'assurance-app-view'
    });
}

function getCompleteParams(customParams) {
    return _.cloneDeep(_.assign(getCommonParams(), _.cloneDeep(customParams)));
}

//  Dashboard-like views

function getDashboardParams() {
    var viewName = 'dashboard';
    return getCompleteParams({
        pageId: 'assurance-' + viewName,
        title: 'My Dashboards',
        view: 'assurance-dashboard-view-' + viewName,
        viewId: viewName
    });
}

//  Dataset-like views

function getDatasetParams(viewName, title, hasDateRangePicker) {
    return getCompleteParams({
        datasetName: viewName,
        hasDateRangePicker: hasDateRangePicker,
        pageId: 'assurance-' + viewName,
        permission: 'viewDatasets',
        title: title,
        view: 'assurance-dataset-view-' + viewName
    });
}

function getCallsParams() {
    return getDatasetParams('calls', 'Calls', true);
}

function getEndpointsParams() {
    return getDatasetParams('endpoints', 'Endpoints');
}

function getSystemsParams() {
    return getDatasetParams('systems', 'Infrastructure');
}
function getEventsParams() {
    return getDatasetParams('events', 'Events', true);
}

function getSpacesParams() {
    return getDatasetParams('spaces', 'Spaces');
}

function getBuildingsParams() {
    return getDatasetParams('buildings', 'Buildings');
}
function getNetworksParams() {
    return getDatasetParams('networks', 'Networks');
}
function getSensorsParams() {
    return getDatasetParams('sensors', 'Sensors');
}

function getMeetingsParams() {
    return getDatasetParams('meetings', 'Meetings', true);
}

function getTrunksParams() {
    return getDatasetParams('trunks', translationService.translate('assuranceTrunks'));
}

//  Existing views (from common and realtime)

function getAlertsParams() {
    return getCompleteParams({ view: 'realtime-alerts-view', permission: 'alertsManager' });
}

function getAlerts3Params() {
    var viewName = 'alerts';

    return getCompleteParams({
        datasetName: viewName,
        hasDateRangePicker: false,
        pageId: 'assurance-' + viewName,
        title: 'Monitors',

        view: 'assurance-alerts-view',
        permission: 'alertsManager'
    });
}

function getAlertDetailsParams() {
    return getCompleteParams({
        view: 'assurance-alert-details-view',
        permission: 'alertsManager'
    });
}

function getSettingsParams() {
    return getCompleteParams({ view: 'settings-view', permission: 'settings-view' });
}

//  Configured Monitoring routes

export default [
    { url: 'assurance/dashboard', params: getDashboardParams() },
    { url: 'assurance/dashboard/tabid/{tabId}', params: _.assign(getDashboardParams(), { level: 'tab' }) },
    { url: 'assurance/infrastructure', params: getSystemsParams() },
    { url: 'assurance/endpoints', params: getEndpointsParams() },
    // { url: 'assurance/endpoint/{epid}/tabid/{tabId}', params: { page: 'assurance-app-view', view: 'endpoint-detail-view', level: 'filter' } },
    { url: 'assurance/meetings', params: getMeetingsParams() },
    { url: 'assurance/calls', params: getCallsParams() },
    // legacy
    { url: 'assurance/calls/{day}/{startTime}/{callId}/container', params: { page: 'assurance-call-details-container-view', view: 'assurance-call-details-view', level: 'view' } },
    // optional :day: for legacy purposes - it's no longer used
    { url: 'assurance/calls/:day:/{startTime}/{callId}?container', params: { page: 'assurance-call-details-container-view', view: 'assurance-call-details-view', level: 'view' } },
    { url: 'assurance/calls/:day:/{startTime}/{callId}', params: { page: 'assurance-app-view', view: 'assurance-call-details-view', level: 'view' } },
    { url: 'assurance/alerts', params: getAlertsParams() },
    { url: 'assurance/alerts/params/{params}', params: _.assign(getAlertsParams(), { level: 'filter' }) },
    { url: 'assurance/settings', params: getSettingsParams() },
    { url: 'assurance/settings/tabid/{tabId}', params: _.assign(getSettingsParams(), { level: 'tab' }) },
    { url: /assurance\/?.*/, params: _.assign({ redirect: 'assurance/dashboard' }, getDashboardParams()) },
    //
    // renamed to monitoring
    //
    { url: 'monitoring/dashboard', params: getDashboardParams() },
    { url: 'monitoring/dashboard/tabid/{tabId}', params: _.assign(getDashboardParams(), { level: 'tab' }) },
    { url: 'monitoring/infrastructure', params: getSystemsParams() },
    { url: 'monitoring/events', params: getEventsParams() },
    { url: 'monitoring/spaces', params: getSpacesParams() },
    { url: 'monitoring/buildings', params: getBuildingsParams() },
    { url: 'monitoring/networks', params: getNetworksParams() },
    { url: 'monitoring/endpoints', params: getEndpointsParams() },
    { url: 'monitoring/sensors', params: getSensorsParams() },
    { url: 'monitoring/meetings', params: getMeetingsParams() },
    { url: 'monitoring/calls', params: getCallsParams() },
    { url: 'monitoring/trunks', params: getTrunksParams() },
    { url: 'monitoring/endpoints/{epid}/tabid/{tabId}', params: { page: 'assurance-app-view', view: 'endpoint-detail-view', level: 'filter', title: 'Endpoint Details' } },
    // legacy
    { url: 'monitoring/calls/{day}/{startTime}/{callId}/container', params: { page: 'assurance-call-details-container-view', view: 'assurance-call-details-view', level: 'view' } },
    // legacy
    // optional :day: for legacy purposes - it's no longer used except in peoples bookmarks
    { url: 'monitoring/endpoint/{epid}/tabid/{tabId}', params: { page: 'assurance-app-view', view: 'endpoint-detail-view', level: 'filter', title: 'Endpoint Details' } }, // legacy
    { url: 'monitoring/calls/:day:/{startTime}/{callId}?container', params: { page: 'assurance-call-details-container-view', view: 'assurance-call-details-view', level: 'view' } },
    { url: 'monitoring/calls/{startTime}/{callId}?top', params: { page: 'assurance-call-details-container-view', view: 'assurance-call-details-view', level: 'view' } },
    { url: 'monitoring/calls/{uniqueId}?top', params: { page: 'assurance-call-details-container-view', view: 'assurance-call-details-view', level: 'view' } },
    { url: 'monitoring/calls/:day:/{startTime}/{callId}', params: { page: 'assurance-app-view', view: 'assurance-call-details-view', level: 'view' } },
    { url: 'monitoring/calls/{uniqueId}', params: { page: 'assurance-app-view', view: 'assurance-call-details-view', level: 'view' } },
    { url: 'monitoring/alerts', params: getAlertsParams() },
    { url: 'monitoring/moi', params: getAlerts3Params() },
    { url: 'monitoring/moi/{id}', params: getAlertDetailsParams() },
    { url: 'monitoring/alerts/params/{params}', params: _.assign(getAlertsParams(), { level: 'filter' }) },
    { url: 'monitoring/settings', params: getSettingsParams() },
    { url: 'monitoring/settings/tabid/{tabId}', params: _.assign(getSettingsParams(), { level: 'tab' }) },
    { url: /monitoring\/?.*/, params: _.assign({ redirect: 'monitoring/dashboard' }, getDashboardParams()) },
    //redirect all realtime routes to the default dashboard
    { url: /realtime\/?.*/, params: _.assign({ redirect: 'assurance/dashboard' }, getDashboardParams()) },
];
